import * as z from 'zod'

export const bookingPaymentStatusSchema = z.object({
  campsiteName: z.string().optional().nullable(),
  bookingUrl: z.string(),
  error: z.string().optional(),
  errorCode: z.string().optional(),
  isPaid: z.boolean(),
  isPaypal: z.boolean(),
  needsPostSca: z.boolean().optional(),
  order: z.object({ id: z.string() }).optional().nullable(),
  payment: z
    .object({
      intentId: z.string(),
      status: z.string(),
      clientSecret: z.string(),
      stripeAccount: z.string().nullable(),
    })
    .optional(),
  paymentIntent: z
    .object({
      id: z.string().optional(),
      status: z.string().optional(),
      paymentMethod: z.string().nullable(),
      nextAction: z
        .object({
          type: z.string(),
          redirectToUrl: z
            .object({
              url: z.string(),
              returnUrl: z.string().optional(),
            })
            .optional(),
        })
        .optional()
        .nullable(),
    })
    .optional(),
  paypalUrl: z.string().optional().nullable(),
  prettyId: z.string().optional(),
  signature: z.string().optional().nullable(),
  taskStatus: z.string().optional().nullable(),
})

export type BookingPaymentStatus = z.infer<typeof bookingPaymentStatusSchema>
